export const GlobalReducer = (state, action) => {
    switch (action.type) {
        case "SET_SUBSCRIPTION":
            return {
                ...state,
                subscription: action.payload
            }
        case "SET_ORGANIZATION":
            return {
                ...state,
                organization: action.payload
            }
        case "SET_ORGANIZATIONS":
            return {
                ...state,
                organizations: action.payload
            }
        case "SET_USER":
            return {
                ...state,
                user: action.payload
            }
        default:
            return state
    }
}